<template>
  <v-form
    lazy-validation
    v-model="valid"
    @submit.prevent="submit"
    ref="form"
  >
      <v-container class="text-center">
        <h1>Canning Process</h1>
        <div :class="{ dimmed: localCanningProcess.status }">
        <v-text-field
          filled
          data-cy="FormCanningProcess-productionCode"
          :label="$$t('productionCode')"
          v-model="localCanningProcess.productionCode"
        />
        <v-text-field
          filled
          data-cy="FormCanningProcess-batchCodes"
          label="Farm Code"
          v-model="localCanningProcess.batchCodes"
        />
        <v-checkbox
          data-cy="FormCanningProcess-fillerOpened"
          v-model="localCanningProcess.fillerOpened"
          :label="$$t('fillerOpened')"
        ></v-checkbox>
        <v-checkbox
          data-cy="FormCanningProcess-weigherVerified"
          v-model="localCanningProcess.weigherVerified"
          :label="$$t('weigherVerified')"
        ></v-checkbox>
        <v-checkbox
          data-cy="FormCanningProcess-codingSameAsProductionCode"
          v-model="localCanningProcess.codingSameAsProductionCode"
          :label="$$t('codingSameAsProductionCode')"
        ></v-checkbox>
        <v-text-field
          filled
          data-cy="FormCanningProcess-ingoingTemperature"
          :label="$$t('ingoingTemperature')"
          v-model="localCanningProcess.ingoingTemperature"
        />
        <ColouredValueSimple
          v-model="localCanningProcess.ingoingTemperature"
          :min="60"
          :max="70"
        />
        <v-text-field
          filled
          data-cy="FormCanningProcess-meatTemp"
          label="Temperature of meat in test can (>30 degrees C)"
          v-model="localCanningProcess.meatTemp"
        />
        <ColouredValueSimple
          v-model="localCanningProcess.meatTemp"
          :min="30"
          :max="100"
        />
        <v-checkbox
          data-cy="FormCanningProcess-seamingDone"
          v-model="localCanningProcess.seamingDone"
          :label="$$t('seamingDone')"
        ></v-checkbox>
        <v-textarea
          filled
          data-cy="FormCanningProcess-comments"
          :label="$$t('comments')"
          v-model="localCanningProcess.comments"
        />
          <v-textarea
          filled
          data-cy="FormCanningProcess-correctiveAction"
          :label="$$t('correctiveAction')"
          v-model="localCanningProcess.correctiveAction"
        />
        <hr class="mb-5 mt-5" />
        </div>
        <div :class="{ dimmed: localCanningProcess.status }">
          <SignVerification role="Process Controller"
            v-model="localCanningProcess.requestedBySignature" />
          <v-row>
            <v-col cols="12" class="mb-10">
              <v-btn block color="success" @click="handover('Verified By')">Handover</v-btn>
            </v-col>
          </v-row>
        </div>
        <div :class="{ dimmed: localCanningProcess.status !== 'Verified By' }">
          <SignVerification role="Production Manager" title="Verified By"
            v-model="localCanningProcess.verifiedBySignature"/>
          <v-row>
            <v-col cols="12" class="mb-10">
              <v-btn block color="success" @click="handover('Ready for NRCS')">Handover</v-btn>
            </v-col>
          </v-row>
        </div>
        <div :class="{ dimmed: localCanningProcess.status !== 'Ready for NRCS' }">
          <SignVerification role="Nrcs" title="NRCS Inspector"
            v-model="localCanningProcess.ncrsSignature"/>
          <v-row>
            <v-col cols="12" class="mb-10">
              <v-btn block color="success" @click="handover('Completed')">Completed</v-btn>
            </v-col>
          </v-row>
        </div>
        <div class="d-flex justify-end mb-6">
          <v-btn color="default" outlined class="ml-4 btn-cancel" @click="cancel"
            data-cy="FormCanningProcess-button-cancel">
            {{ $t('common.buttons.cancel') }}
          </v-btn>
          <v-btn color="primary" type="submit" class="ml-4" :loading="isSaving"
            data-cy="FormCanningProcess-button-save">
              {{ $t('common.buttons.save') }}
            </v-btn>
        </div>
      </v-container>
  </v-form>
</template>

<script>
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import formChecklist from './formChecklist';
import SignVerification from './SignVerification.vue';
import ColouredValueSimple from './ColouredValueSimple.vue';

export default {
  name: 'FormCanningProcess',
  module: 'CanningProcess',
  components: {
    ColouredValueSimple,
    SignVerification,
  },
  mixins: [formChecklist, loading],
  props: {
    /**
    * Set the text box value. Default: undefined,
    */
    CanningProcess: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      /**
      * Hold form validation state
      */
      valid: false,
      /**
      * Local value used for property localCanningProcess
      */
      localCanningProcess: {},
    };
  },
  watch: {
    CanningProcess() {
      this.localCanningProcess = this.CanningProcess;
    },
  },
  created() {
    this.localCanningProcess = this.CanningProcess;
  },
  methods: {
    handover(status) {
      this.localCanningProcess.status = status;
      this.$emit('save', this.localCanningProcess);
    },
    /** Submit Form data trigger
     * @event save
     * @type {object}
     */
    submit() {
      // validate
      if (this.$refs.form.validate()) {
        this.$emit('save', this.localCanningProcess);
        this.isSaving = true;
      }
    },
    /** Cancel form trigger
     * @event cancel
     */
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<docs>
# FormCanningProcess example

'''js
<FormCanningProcess :CanningProcess="CanningProcess" />
'''
</docs>
